import type { ReactNode } from 'react';

export const symbol_tv_next: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M868-230 768-330q-10-9.96-10-22.98t9.97-23.02q9.96-10 23-10Q804-386 814-376l126 125q9 9 9 21t-9 21L814-83q-9.96 10-22.98 10T768-83.18q-10-10.19-10-23.5Q758-120 768-130l100-100ZM360-120q-12.75 0-21.37-8.63Q330-137.25 330-150v-50H140q-24 0-42-18t-18-42v-520q0-24 18-42t42-18h680q24 0 42 18t18 42v267q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63-8.5-8.62-8.5-21.37v-267H140v520h516q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5h-26v50q0 12.75-8.62 21.37Q612.75-120 600-120H360ZM140-260v-520 520Z"
		/>
	</svg>
);
